export const IDLE = 'idle';
export const PENDING = 'pending';
export const REJECTED = 'rejected';
export const INVALID_TOKEN = 'invalid_token';
export const RESOLVED = 'resolved';
